require('../css/record.css');

/* JS pour la barre de recherche des chevaux */

const researchInput = document.getElementById('myInput');

if (researchInput != null) {
    researchInput.addEventListener('keyup', function searchHorseName() {
        var filter, horseName, i, div ;
        filter = researchInput.value.toUpperCase();
        div = document.querySelectorAll('.myResearch');
        // Loop through all list items, and hide those who don't match the search query
        for (i = 0; i < div.length; i++) {
            horseName = div[i];
            if (horseName.innerHTML.toUpperCase().indexOf(filter) > -1) {
                div[i].style.display = "";
            }
            else {
                div[i].style.display = "none";
            }
        }
    });
}

if (document.getElementById('record') != null) {
    const paginationBlock = document.getElementById('record').lastElementChild ;
    const linkNextPage = paginationBlock.querySelectorAll('a');

    if (linkNextPage != null) {
        linkNextPage.forEach(function (item) {
            item.rel = "nofollow";
        });
    }
}
